/* eslint-disable @typescript-eslint/no-explicit-any */
import MiiaFwConfig from '@/configs/config'
import { useApiGw } from '@/features/miiaFw/composables/useApiGw'
import { ERROR_MESSAGES } from '@/constants/error/errorMessage'
import { ERROR_CODES } from '@/constants/error/errorCode'
import type {
  GeoRunGeoserverRequestParam,
  GeoRunGeoserverResponseParam
} from '@/types/api/geoserver/geoserverTypes'

export const geoRunGeoserverApi = () => {
  const callRunGeoserver = async (
    arg: GeoRunGeoserverRequestParam
  ): Promise<GeoRunGeoserverResponseParam> => {
    return await new Promise((resolve, reject) => {
      useApiGw().invokeApiGwFunc(
        // API Gatewayのエンドポイント
        MiiaFwConfig.config.apiGwEndpointScreening,
        // Lambda関数をコールするためのWebAPIのサブディレクトリ
        `/geoserver/run`,
        // Lambda関数に渡す引数
        {
          function: 'run_geoserver',
          params: {
            ...arg,
            system: MiiaFwConfig.config.sysId
          }
        },
        // Lambda関数実行前の前処理のコールバック
        () => {},
        // 成功時のコールバック
        (response: GeoRunGeoserverResponseParam) => {
          resolve(response)
        },
        // 例外受信時のコールバック(引数: エラーメッセージ)
        (message: any) => {
          reject({ message: message })
        },
        // 予期せぬエラー(アクセス回線障害など)発生時のコールバック
        () => {
          reject({ message: ERROR_MESSAGES[ERROR_CODES.API_EXECUTION_FAILED].message })
        },
        // 処理完了後に実行するコールバック
        () => {}
      )
    })
  }

  return {
    callRunGeoserver
  }
}
